module.exports = __webpack_public_path__ + "static/media/wrong-answer-sound.59de24e3.mp3";